import { useQuery } from 'convex/react';
import { api } from '../../../convex/_generated/api';

export interface DirectorStats {
  totalPlayers: number;
  totalCoaches: number;
  totalParents: number;
  sessionsThisWeek: number;
  avgAttendance: number;
  recentEvaluations: number;
}

export interface OrgAnalytics {
  overallStats: {
    avgEffort: number;
    avgEngagement: number;
    avgCompetition: number;
    avgAttitude: number;
    totalEvaluations: number;
  } | null;
  chartData: Array<{
    date: string;
    effort: number;
    engagement: number;
    competitionLevel: number;
    attitude: number;
    count: number;
  }>;
  topPerformers: Array<{
    playerId: string;
    name: string;
    overall: number;
    effort: number;
    engagement: number;
    competitionLevel: number;
    attitude: number;
    evalCount: number;
  }>;
  needsAttention: Array<{
    playerId: string;
    name: string;
    overall: number;
    effort: number;
    engagement: number;
    competitionLevel: number;
    attitude: number;
    evalCount: number;
  }>;
}

export function useDirectorStats() {
  const data = useQuery(api.director.stats.get);
  return { data, isLoading: data === undefined, error: null };
}

export function useOrgAnalytics() {
  const data = useQuery(api.director.analytics.get);
  return { data, isLoading: data === undefined, error: null };
}
